import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Send, Pin, MapPinned, MapPinPlus } from 'lucide-react';
import '../styles/journey-loading.css';

/**
 * A full-screen blocking loading animation using a Portal.
 */
export default function JourneyLoading({ stage = 'flying' }) {
    const [render, setRender] = useState(true);

    useEffect(() => {
        if (stage === 'done') {
            const timeout = setTimeout(() => setRender(false), 800); // Wait for exit animation
            return () => clearTimeout(timeout);
        }
        setRender(true);
    }, [stage]);

    if (!render) return null;

    return createPortal(
        <div className={`journey-loading ${stage === 'plotting' ? 'is-plotting' : ''} ${stage === 'done' ? 'is-done' : ''}`}>
            <div className="journey-loading__plane-wrapper">
                <Send className="journey-loading__plane" size={48} />
            </div>
            <div className="journey-loading__timeline">
                <div className="loading-point">
                    <Pin size={24} />
                </div>
                <div className="loading-point">
                    <MapPinned size={24} />
                </div>
                <div className="loading-point">
                    <MapPinPlus size={24} />
                </div>
            </div>
            <div className="journey-loading__message">
                {stage === 'flying' ? 'Charting your journey...' : 'Arranging the timeline...'}
            </div>
        </div>,
        document.body
    );
}
